import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment-timezone";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import {
  loginToEvent,
  initiateCreateEvent,
  openEventChooser,
  checkClientExpiryDate,
  refreshSessionToken,
  deleteEvent,
  clearAdminEvents,
  getClientEventStatus,
  resetStoreForAdminEvents,
  markLogin,
  getDeviceSize,
} from "Actions";
import { selectDashboardMenu } from "DashboardMenuAction";
import { toggleEditSEOCodeEditor } from "GeneralTabAction";
import { proceedToDashboard } from "SignupActions";
import { showError, showSuccess } from "ReduxErrorBar";
import { BASE_IMAGES_URL } from "Constants";
import LocaleStrings from "Languages";

class EventItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingDiv: false,
    };
  }

  updateSize = () => {
    // GETTING DYNAMIC HEIGHT AND WIDTH
    this.props.getDeviceSize();
  };

  toggleLoading = () => {
    this.setState({ loadingDiv: !this.state.loadingDiv });
    this.props.toggleEditSEOCodeEditor(false);
  };

  addEvent = () => {
    var { event, clientdataforbilling, total_accountusageCount } = this.props;

    let userlimitexceeded = false;
    let clientuserlimit = 0;
    let usedcredits = 0;
    if (
      clientdataforbilling &&
      clientdataforbilling.data &&
      clientdataforbilling.data.length > 0
    ) {
      clientuserlimit = parseInt(clientdataforbilling.data[0].userlimit);
    }
    if (total_accountusageCount && total_accountusageCount.count) {
      usedcredits = parseInt(total_accountusageCount.count);
    }

    if (usedcredits > clientuserlimit) {
      userlimitexceeded = true;
    }

    if (userlimitexceeded == false) {
      confirmAlert({
        title: LocaleStrings.event_chooser_add_event_title,
        message: LocaleStrings.event_chooser_add_event_message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        // onConfirm: () => {
        //   this.props.initiateCreateEvent({ initiate: true });
        // },
        // onCancel: () => {},
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.initiateCreateEvent({ initiate: true });
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else {
      this.props.showError("User Limit has been expired");
    }
  };

  gotoToEvent = () => {
    var { session, event } = this.props;

    this.toggleLoading();
    this.props.checkClientExpiryDate(event.eventid, session, (response) => {
      if (response.success == 1) {
        this.props.refreshSessionToken(
          this.props.session,
          { appuserid: event.appuserid },
          (res) => {
            this.toggleLoading();
            this.props.loginToEvent(event);
            this.props.proceedToDashboard();
            this.props.openEventChooser({ showModal: false });
            this.props.isEventDeleted(false); // update parent components state to handle close modal button.

            setTimeout(() => {
              this.updateSize();
            }, 2000);

            if (this.props.insideDashBoard === true) {
              this.props.history.push("/");
            } else {
              this.props.history.push("/dashboard");
            }
          }
        );
      } else {
        // var menuItem = {
        //   iconName: LocaleStrings.accountsetting_header_title,
        //   description: LocaleStrings.accountsetting_header_subtitle,
        //   bsClass: "accountsettings",
        // };
        // this.props.selectDashboardMenu(menuItem);
        // this.props.markLogin(); // Mark login as true
        // this.props.openEventChooser({ showModal: false });
        // this.props.initiateCreateEvent({ initiate: false });
        // this.props.history.push("/dashboard/accountsettings/billings");
        this.props.showError(LocaleStrings.login_user_session_expired);
        this.toggleLoading();
      }
    });
  };

  handleDelete = (e) => {
    let { session, user, event } = this.props;
    let { loaddDltBtm } = this.state;
    e.preventDefault();
    e.stopPropagation();

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.event_delete_title}</h1>
            <p>{LocaleStrings.event_delete_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.clearAdminEvents();
                  onClose();
                  this.props.deleteEvent(session, event.eventid, (repsonse) => {
                    if (repsonse.success == 0) {
                      this.props.showError(LocaleStrings.event_delete_error1);
                    } else {
                      this.props.resetStoreForAdminEvents(); // We are clearing all the redux store data.
                      this.props.openEventChooser({ showModal: true }); // we are callng this, as we are deleting all the redux state. To keep open the Modal we are recalling this.

                      this.props.getClientEventStatus(
                        user,
                        session,
                        (response) => {
                          // console.log("response :- ", response);

                          // if (response.success && response.adminevents === "") {
                          //   this.props.resetStoreForAdminEvents();
                          //   this.props.openEventChooser({ showModal: true }); // we are callng this, as we are deleting all the redux state. To keep open the Modal we are recalling this.
                          // }

                          this.updateSize();
                          this.props.isEventDeleted(true); // update parent components state to handle close modal button.
                        }
                      );
                    }
                  });
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose} disabled={loaddDltBtm}>
                {LocaleStrings.button_cancel}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  render() {
    var { event, user } = this.props;
    var {
      eventicon,
      eventname,
      eventstartdate,
      eventenddate,
      themecolor,
      addevent,
      clientidfk,
      group_number,
      plantype,
    } = event;

    var formatteddate = "";

    var imageurl =
      "../../style/images/v2_icons/branding/branding_icon_placeholder.png";
    if (eventicon)
      imageurl = `${BASE_IMAGES_URL}/${eventicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;

    var style = {
      marginTop: "20px",
      marginLeft: "20px",
      // position: "absolute",
      height: "80px",
      width: "80px",
      borderRadius: "15px",
    };

    var innerContainerStyle = {
      background: `${themecolor}`,
      width: "100%",
      height: "135px",
      display: "flex",
    };

    if (!addevent) {
      var dt_start = moment(eventstartdate, "YYYY-MM-DD");
      var dt_end = moment(eventenddate, "YYYY-MM-DD");

      var startDay = dt_start.format("DD");
      var startMonthName = dt_start.format("MMMM");
      var startYear = dt_start.format("YYYY");

      var endDay = dt_end.format("DD");
      var endMonthName = dt_end.format("MMMM");
      var endYear = dt_end.format("YYYY");

      if (startYear == endYear && startMonthName != endMonthName) {
        formatteddate = `${startDay} ${startMonthName} - ${endDay} ${endMonthName} ${endYear}`;
      } else if (startYear != endYear) {
        formatteddate = `${startDay} ${startMonthName} ${startYear} - ${endDay} ${endMonthName} ${endYear}`;
      } else if (startDay == endDay) {
        formatteddate = `${startDay} ${startMonthName} ${startYear}`;
      } else {
        formatteddate = `${startDay} - ${endDay} ${endMonthName} ${endYear}`;
      }
    }

    let plantypestyle = {
      background: "#43ff64d9",
    };

    if (plantype == "myhub") {
      plantypestyle = {
        background: "#105efb",
        color: "#fff",
      };
    } else if (plantype == "whitelabel") {
      plantypestyle = {
        background: "#fff",
      };
    } else if (plantype == "multiplewhitelabel") {
      plantypestyle = {
        background: "#fff",
      };
    }

    return (
      <div className="position-relative">
        {addevent ? (
          <div
            className="add-eventcard"
            onClick={this.state.loadingDiv ? null : this.addEvent}
          >
            <span className="add-eventcard-button">+</span>
          </div>
        ) : (
          <div
            className="eventcard"
            onClick={this.state.loadingDiv ? null : this.gotoToEvent}
          >
            <div style={innerContainerStyle}>
              <img src={imageurl} style={style} />
              <div className="plantypetag" style={plantypestyle}>
                {plantype == "trial"
                  ? "Trial"
                  : plantype == "myhub"
                  ? "My Hub"
                  : plantype == "whitelabel"
                  ? "White Label"
                  : plantype == "multiplewhitelabel"
                  ? "White Label Multiple"
                  : plantype == "myhubgroup"
                  ? "My Hub Group"
                  : "No Plan Added"}
              </div>
            </div>

            <div className="eventdetails">
              <div>
                <div className="custom-text1-primary-medium">{eventname}</div>
                <div className="custom-text2-secondary-normal">
                  {formatteddate}
                </div>
              </div>

              {clientidfk == user.clientid &&
              group_number == user.groupNumber ? (
                <div>
                  <button
                    className="i-custom-table-delete"
                    onClick={
                      this.state.loadingDiv ? null : (e) => this.handleDelete(e)
                    }
                  >
                    <img
                      className="button-delete-icon"
                      src="../../style/images/delete.png"
                      alt="delete-user"
                    />
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* <div className="d-flex justify-content-end mr-10 ">
              {CheckEventValidity(eventenddate) ? (
                <span className="event-valid font-weight-bold">
                  {LocaleStrings.valid_event_validity_string}
                  {eventenddate}
                </span>
              ) : (
                <span className="event-expired">
                  {LocaleStrings.expired_event_validity_string}
                </span>
              )}
            </div> */}
          </div>
        )}

        {this.state.loadingDiv ? <SpinerDiv /> : ""}
      </div>
    );
  }
}

const SpinerDiv = (props) => {
  return (
    <div className="loading-spinner">
      <div></div>
    </div>
  );
};

const CheckEventValidity = (expectedEventEndDate) => {
  let eventdate = expectedEventEndDate;
  let todaydate = new Date();

  if (new Date(eventdate).getTime() <= todaydate.getTime()) {
    return false;
  }
  return true;
};

var mapStateToProps = (state) => {
  return {
    session: state.session,
    user: state.user,
    clientdataforbilling: state.clientdataforbilling,
    total_accountusageCount: state.total_accountusageCount,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    showError,
    showSuccess,
    openEventChooser,
    loginToEvent,
    initiateCreateEvent,
    proceedToDashboard,
    checkClientExpiryDate,
    refreshSessionToken,
    toggleEditSEOCodeEditor,
    deleteEvent,
    clearAdminEvents,
    getClientEventStatus,
    resetStoreForAdminEvents,
    markLogin,
    selectDashboardMenu,
    getDeviceSize,
  })(EventItem)
);
